<ng-container *ngIf="!applicationData.configuration.multiFormat">
  <div class="manager-panel__list" 
       [ngClass]="{
          'manager-panel__list--horizontal': template == 'horizontal', 
          'manager-panel__list--horizontal-cut': template == 'horizontal-cut', 
          'manager-panel__list--vertical': template == 'vertical', 
          'manager-panel__list--vertical-cut': template == 'vertical-cut'
        }" #scroller>
    <div *ngFor="let labelData of applicationData.configuration.labels; let i = index"
        class="manager-panel__item" 
        [ngClass]="{
          'manager-panel__item--selected': applicationData.configuration.currentLabel == labelData
        }">
      <div class="manager-item">
        <div class="manager-item__num">{{ (i + 1) }}</div>
        <div class="manager-item__preview">
          <label-preview [ratio]="ratio" [label]="labelData" (click)="selectLabel(labelData)"></label-preview>
        </div>
        <div class="manager-item__actions">
          <span class="icon icon-copy-2" (click)="requestLabelDuplication(previews, labelData)"></span>
          <span class="icon icon-delete" (click)="requestLabelDeletion(labelData)"></span>
        </div>
      </div>
    </div>
  </div>  
</ng-container>
<ng-container *ngIf="applicationData.configuration.multiFormat">
  <div class="manager-panel__list manager-panel__list--sheet">
    <!-- <div class="manager__item" *ngFor="let labelData of applicationData.configuration.sheets; let i = index">
      <sheet-preview (onLabelSelected)="selectLabel($event)" [index]="i" [width]="182" [height]="154"></sheet-preview>
    </div> -->
    <div class="manager-panel__num">
    {{ (currentSheet + 1) }} / {{ applicationData.configuration.sheets.length }}
    </div>
    <div class="manager__item">
      <span 
        class="manager-panel__arrow manager-panel__prev" 
        [ngClass]="{
          'manager-panel__arrow--disable': currentSheet <= 0
        }"
        (click)="prevSheet()"
      ></span>
      <sheet-preview (onLabelSelected)="selectLabel($event)" [index]="currentSheet" [interactive]="true" [ratio]="ratio"></sheet-preview>
      <span 
        class="manager-panel__arrow manager-panel__next" 
        [ngClass]="{
          'manager-panel__arrow--disable': currentSheet >= applicationData.configuration.sheets.length - 1
        }"
        (click)="nextSheet()"
      ></span>
    </div>
    <div class="manager-panel__actions">
      <span class="icon icon-copy-2" (click)="requestLabelDuplication(previews, applicationData.configuration.currentLabel)"></span>
      <span class="icon icon-delete" (click)="requestSheetDeletion(currentSheet)"></span>
    </div>
  </div>
</ng-container>
<div class="manager-panel__add">
  <button *ngIf="!applicationData.configuration.multiFormat" class="text-button" (click)="addLabel()"><span class="text-button__icon icon icon-round-add-button"></span><span class="text-button__label">{{ 'cfg_add_label' | translate }}</span></button>
  <button *ngIf="applicationData.configuration.multiFormat" class="text-button" (click)="addSheet()"><span class="text-button__icon icon icon-round-add-button"></span><span class="text-button__label">{{ 'cfg_add_sheet' | translate }}</span></button>
</div>

<app-modal id="modal-confirm-label-deletion" width="640" [blocking]="true" #mcld2>
  <p *ngIf="mcld2.data?.text" [innerHtml]="mcld2.data?.text | translate"></p>

  <div class="modal__buttons">
    <button class="button button--square" (click)='mcld2.close()'>
      <span>{{ 'btn_cancel' | translate }}</span>
    </button>

    <button class="button button--square" (click)='deleteLabel(mcld2.data?.label)'>
      <span>{{ 'btn_ok' | translate }}</span>
    </button>
  </div>
</app-modal>

<app-modal id="modal-confirm-sheet-deletion" width="640" [blocking]="true" #mcsd>
  <p *ngIf="mcsd.data?.text" [innerHtml]="mcsd.data?.text | translate"></p>

  <div class="modal__buttons">
    <button class="button button--square" (click)='mcsd.close()'>
      <span>{{ 'btn_cancel' | translate }}</span>
    </button>

    <button class="button button--square" (click)='deleteSheet(mcsd.data?.sheet)'>
      <span>{{ 'btn_ok' | translate }}</span>
    </button>
  </div>
</app-modal>

<app-modal id="modal-duplication" width="640" [blocking]="false" #md>
  <div class="preview-panel">
    <div class="preview-panel__sheet">
      <sheet-preview [index]="currentDuplicationSheet" [interactive]="false" [duplicateMode]="true" [reference]="md.data?.label" [selected]="selectedLabels" [ratio]="0.3" #previews></sheet-preview>
    </div>
    <div class="preview-panel__pagination">
      <pagination [total]="applicationData.configuration.sheets.length" (onSetPage)="currentDuplicationSheet = $event">
      </pagination>

      <button class="button button--square" (click)='duplicateLabel(md.data?.label)'>
        <span>{{ 'cfg_continue' | translate }}</span>
      </button>
    </div>
  </div>
</app-modal>